import React from "react";
import styled from "styled-components";
import useI18n from "../../i18n/useI18n";
import termsContent from "./data";

const DocumentsContainer = styled.div`
    padding: 1em;
    max-width: 900px;
    margin: 0 auto;
    color: #333;

    h1 {
        font-size: 2.5rem;
        font-weight: bold;
    }

    h2 {
        font-size: 1.8rem;
        font-weight: bold;
    }

    h3 {
        font-size: 1.4rem;
    }

    p {
        font-size: 1rem;
        line-height: 1.6;
        margin-bottom: 1em;
    }

    ul,
    ol {
        margin: 1em 0;
        padding-left: 1.5em;
    }

    li {
        margin-bottom: 0.5em;
    }

    a {
        color: #1a73e8;
        text-decoration: none;
    }

    a:hover {
        text-decoration: underline;
    }
`;

const Policy = () => {
    const { translateObject } = useI18n();

    return (
        <DocumentsContainer>
            <h1>{translateObject(termsContent.title)}</h1>
            <p>
                <strong>{translateObject(termsContent.effectiveDate)}</strong>{" "}
                {translateObject(termsContent.date)}
            </p>
            <p>{translateObject(termsContent.introduction)}</p>

            <h2>1. {translateObject(termsContent.acceptance)}</h2>
            <p>{translateObject(termsContent.acceptanceText)}</p>

            <h2>2. {translateObject(termsContent.eligibility)}</h2>
            <p>{translateObject(termsContent.eligibilityText)}</p>

            <h2>3. {translateObject(termsContent.userAccounts)}</h2>
            <p>{translateObject(termsContent.userAccountsText)}</p>

            <h2>4. {translateObject(termsContent.serviceDescription)}</h2>
            <p>{translateObject(termsContent.serviceDescriptionText)}</p>
            <ul>
                {termsContent.serviceTools.map((tool, i) => (
                    <li key={i}>{translateObject(tool)}</li>
                ))}
            </ul>
            <p>{translateObject(termsContent.evolvingServices)}</p>

            <h2>5. {translateObject(termsContent.restrictions)}</h2>
            <p>{translateObject(termsContent.restrictionsText)}</p>
            <ul>
                {termsContent.restrictionList.map((restriction, i) => (
                    <li key={i}>{translateObject(restriction)}</li>
                ))}
            </ul>

            <h2>6. {translateObject(termsContent.payment)}</h2>
            <p>{translateObject(termsContent.paymentText)}</p>

            <h2>7. {translateObject(termsContent.intellectualProperty)}</h2>
            <p>{translateObject(termsContent.intellectualPropertyText)}</p>

            <h2>8. {translateObject(termsContent.disclaimer)}</h2>
            <p>{translateObject(termsContent.disclaimerText)}</p>

            <h2>9. {translateObject(termsContent.liability)}</h2>
            <p>{translateObject(termsContent.liabilityText)}</p>

            <h2>10. {translateObject(termsContent.governingLaw)}</h2>
            <p>{translateObject(termsContent.governingLawText)}</p>

            <h2>11. {translateObject(termsContent.changes)}</h2>
            <p>{translateObject(termsContent.changesText)}</p>

            <h2>12. {translateObject(termsContent.contact)}</h2>
            <p>
                {translateObject(termsContent.contactUs)}
                <a href={`mailto:legal@appsinti.com`}>legal@appsinti.com</a>
            </p>
        </DocumentsContainer>
    );
};

export default Policy;
